<template>
  <!-- 附件管理 -->
  <div class="dialog-root">
    <div class="container">
      <UploadTable v-bind="$attrs" @update="updateAttachList"></UploadTable>
    </div>
    <!-- 按钮占位区域 -->
    <div class="placeholder"></div>
    <!-- 底部操作按钮 -->
    <div class="btn">
      <el-button type="primary" size="small" @click="doSave">提交</el-button>
      <el-button size="small" @click="doClose">取消</el-button>
    </div>
  </div>
</template>

<script>
import UploadTable from '@/views/crmedical/warehouse/components/upload-table';

export default {
  name: 'AttachManagement',
  components: {
    UploadTable,
  },
  data() {
    return {
      attachList: [], // 附件列表
    };
  },
  created() {
    this.attachList = this.$attrs.fileList || [];
  },
  methods: {
    /* 附件子组件同步的数据 */
    updateAttachList(data) {
      this.attachList = data;
    },
    /* 保存 */
    doSave() {
      console.log('----------', this.attachList);
      this.$emit('save', this.attachList);
    },
    /* 取消 */
    doClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-root {
  /* 给按钮的父元素加一个相对定位，方便按钮的布局 */
  position: relative;
  /* 内容容器 */
  .container {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    max-height: 60vh;
    padding: 0 10px;
    overflow: scroll;
  }
  /* 按钮占位区域 */
  .placeholder {
    height: 50px;
  }
  /* 底部固定的按钮区域 */
  .btn {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background: #fff;
  }
}
</style>
